import { Loading } from '@/components/ui/daisy';
import usePedagogicalContents from '@/data/hook/ped-content/usePedagogicalContents';
import PedContentCard from './PedContentCard';
import PedContentFormList from './PedContentFormList';

type PedContentTabContentProps = {
  moduleId: number;
  courseLineId: number;
};

export default function PedContentTabContent({
  moduleId,
  courseLineId,
}: PedContentTabContentProps) {
  const {
    coursePaths,
    isLoading,
    createCoursePath,
    isCreating,
    deleteCoursePath,
    isDeleting,
  } = usePedagogicalContents({ moduleId, courseLineId });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loading variant="spinner" size="lg" color="primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6 min-w-0">
      {coursePaths.map(coursePath => (
        <PedContentCard
          key={coursePath.id}
          coursePath={coursePath}
          courseLineId={courseLineId}
          moduleId={moduleId}
          onDelete={deleteCoursePath}
          isDeleting={isDeleting}
        />
      ))}
      <PedContentFormList onSubmit={createCoursePath} isLoading={isCreating} />
    </div>
  );
}
